import Footer from "components/Primary/Footer";
import Header from "components/Primary/Header";
import TopBar from "components/TradePage/TopBar";
import TradeBody from "components/TradePage/TradeBody";
import { SOL_TOKEN, USDC_TOKEN } from "helpers/helpers";
import useWindowDimensions from "helpers/screen";
import { useEffect, useState } from "react";
import { useHistory } from 'react-router-dom'
import { UseMarket } from "utils/market";
import "./style.scss";
import queryString from 'query-string';
import { useSelector } from "react-redux";


const TradePage = ({fullyLoaded}) => {
  const state = useSelector((state) => state.storage);

  const history = useHistory();
  const [pair, setPair] = useState({
    base: SOL_TOKEN,
    quote: USDC_TOKEN
  });
  const [market, updateMarket] = UseMarket(pair);
  const [arrangeLayout, setArrangeLayout] = useState([0,1,2]); // layout: Trade body arrangement. [0 = Orderbook, 1 = Chart/Open Orders, 2 = Order Box]
  const {width} = useWindowDimensions();

  useEffect(() => { // First time load (useHistory doesn't work for the first visit)
    if(state.tokenList && fullyLoaded && state.markets) {
      console.log(window.location.search)
      let params = queryString.parse(window.location.search);
      
      if(params.trade) {
        
        let pair = params.trade;
        if(pair.indexOf("-") !== -1) {
          let from = null;
          let to = null;
          for(let i = 0; i < state.tokenList.tokens.length; i++) {
            if(state.tokenList.tokens[i].symbol === pair.split("-")[0])
              from = state.tokenList.tokens[i];
            if(state.tokenList.tokens[i].symbol === pair.split("-")[1])
              to = state.tokenList.tokens[i];
          }
          console.log("Setting tokens to", from, to)
          updateMarket({
            base: from ? from.address : from,
            quote: to ? to.address : to,
          });
        }
      } else if(params.market) {
        let mkt = params.market;
        // for(let i = 0; i < state.markets.length; i++) {
        //   if(state.markets[i].market === mkt) {
            updateMarket({
              // base: state.markets[i].baseToken.address,
              // quote: state.markets[i].quoteToken.address,
              market: mkt,
            })
          // }
        // }
      }
    }
  },[state.tokenList, fullyLoaded,  state.markets]);

  if(!market.pairs) return "";

  return <div className="tradePage">
    <Header/>
    <TopBar marketData={market} updateMarket={updateMarket}/>
    <TradeBody marketData={market} layout={arrangeLayout} setLayout={setArrangeLayout} updateMarket={updateMarket}/>
    { width > 768 &&
      <Footer/>
    }
  </div>
}

export default TradePage;